var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Basket50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M37.117,22.673L32.59,10H15.41l-4.526,12.673l-3.767-1.346l5-14C12.401,6.531,13.155,6,14,6h20 c0.845,0,1.599,0.531,1.883,1.327l5,14L37.117,22.673z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M37.4,43H10.6c-1,0-1.8-0.7-2-1.6L5,23h38l-3.7,18.4C39.1,42.3,38.3,43,37.4,43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66bb6a",
    d: "M43,25H5c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h38c1.1,0,2,0.9,2,2v2C45,24.1,44.1,25,43,25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b5e20",
    d: "M24 28L24 28c-.552 0-1 .448-1 1v10c0 .6.4 1 1 1s1-.4 1-1V29C25 28.448 24.552 28 24 28zM28 28L28 28c-.552 0-1 .448-1 1v10c0 .6.4 1 1 1s1-.4 1-1V29C29 28.448 28.552 28 28 28zM32 28L32 28c-.552 0-1 .448-1 1v10c0 .6.4 1 1 1 .6 0 1-.4 1-1V29C33 28.448 32.552 28 32 28zM16 28L16 28c-.552 0-1 .448-1 1v10c0 .6.4 1 1 1s1-.4 1-1V29C17 28.448 16.552 28 16 28zM20 28L20 28c-.552 0-1 .448-1 1v10c0 .6.4 1 1 1s1-.4 1-1V29C21 28.448 20.552 28 20 28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66bb6a",
    d: "M29,11H19c-0.552,0-1-0.448-1-1V6c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v4 C30,10.552,29.552,11,29,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Basket50);
export default __webpack_public_path__ + "static/media/icons8-basket-50.84b4989b9da3df0b6bea84eace6cb9f1.svg";
export { ForwardRef as ReactComponent };